
























import { Component, Vue, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import BaseVue from "@/core/BaseVue";
import { Route } from "vue-router";
import IndicatorGroup from "@/models/indicator/indicatorGroup.model";
@Component
export default class IndicatorTypeBase extends BaseVue {
  protected id: number|null = null;
  protected loading = false;
  protected repository!: BaseRepository<IndicatorGroup>;
  protected name = '';
  protected model: IndicatorGroup | any = null;

  created() {
      this.id = Number.parseInt(this.$route.params.indicatorGroupId);
    if (this.hasParent && this.model == null) {
      this.repository = new BaseRepository<IndicatorGroup>("IndicatorGroups");
      this.getData();
    }
  }

  @Watch('model')
  onModelChange() {
    if (this.model) this.name = this.hasParent && this.model ? this.model.name : "---";
  }
  gotToList() {
    this.$router.push("/indicatorGroup");
  }
  protected async getData() {
    try {    
      if(this.id) {
        this.model = await this.repository.getById(this.id);
      }
    } catch (errors) {
      this.operationFailedErrors(errors);
    } finally {

    }
  }
  get hasParent() {
    return !!this.$route.params.indicatorGroupId;
  }
}
